import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function WixAuthRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) {
      console.error("❌ No token found in URL");
      navigate("/error");
      return;
    }

    const redirectUrl = process.env.REACT_APP_WIX_REGISTER_URL;
    if (!redirectUrl) {
      console.error("❌ REACT_APP_WIX_REGISTER_URL is not defined");
      navigate("/error");
      return;
    }

    const appId = process.env.REACT_APP_WIX_APP_ID;
    const wixInstallUrl = `https://www.wix.com/installer/install?token=${token}&appId=${appId}&redirectUrl=${encodeURIComponent(redirectUrl)}`;

    // Use timeout to ensure React has rendered and avoid browser blocking
    setTimeout(() => {
      window.location.href = wixInstallUrl;
    }, 100);
  }, [navigate]);

  return (
    <div className="loading-container">
      <div className="spinner"></div>
    </div>
  );
}

export default WixAuthRedirect;
